import { Box, makeStyles } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import { InputButton } from "../../../components/input-button/InputButton";
import { InputPin } from "../../../components/input-pin/InputPin";
import {
  SignupDispatchContext,
  SignupTypeEnum,
} from "../../../context/SignupContext";
import { SignInStateAttributes } from "../SignInScreen";
import { FormikHelpers, useFormik } from "formik";
import { Overlay } from "../../../components/overlay/Overlay";
import { SignupScreen } from "../../signup/SignupScreen";

interface ConfirmPinProps {
  pinLength: number;

  data: SignInStateAttributes;
}

export const useStyles = makeStyles(
  (theme) => ({
    contentInner: {
      margin: "0 auto",
      width: "60%",
    },
  }),
  {
    name: "confirm-pin-style",
    flip: null,
  }
);

export const ConfirmPin = (props: ConfirmPinProps) => {
  const classes = useStyles(props);
  const intl = useIntl();
  const history = useHistory();
  // Props
  const { pinLength, data } = props;
  // State
  const [pin, setPin] = useState("");
  // Context
  // const state = useContext(SignupContext);
  const dispatch = useContext(SignupDispatchContext);

  const handlePinChange = (pin: string) => {
    setPin(pin);

    if (pin.length === pinLength && pin !== data.pin) {
      // Clear
      setPin("");
      formik.setErrors({
        unknown: intl.formatMessage({ id: "error.noMatchPinCode" }),
      });
    } else {
      formik.setErrors({});
    }
  };

  const handleAction = () => {
    if (data.pin === pin) {
      formik.handleSubmit();
    }
  };

  const renderErrors = () => {
    if (formik.errors.unknown) {
      return formik.errors.unknown as string;
    }

    return "";
  };

  const setTempData = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SignupTypeEnum.temp,
        payload: {
          personal: {
            country_iso_code: data.countryIsoCode,
            dial_code: data.dialCode,
            telephone: data.phone,
            pin_code: data.pin,
          },
        },
      });

      setTimeout(() => resolve({}), 1000);
    });
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: async (
      values: any,
      { setErrors, setSubmitting }: FormikHelpers<any>
    ) => {
      try {
        // Set temp data
        await setTempData();
        setSubmitting(false);

        history.replace(SignupScreen.routeName);
      } catch (err) {
        setSubmitting(false);
        setErrors({
          unknown: intl.formatMessage({ id: "error.unknownError" }),
        });
      }
    },
  });

  return (
    <>
      <Box
        marginBottom={1}
        component="span"
        className="title"
        textAlign="center"
      >
        <FormattedMessage id="sharedScreen.confirm" />
      </Box>
      <Box component="div" display="flex" justifyContent="center">
        <Box
          component="span"
          className="subTitle"
          width="80%"
          textAlign="center"
        >
          <FormattedMessage id="sharedScreen.confirmNDigitPinNotice" />
        </Box>
      </Box>

      <Box component="div" mt={6}>
        <Box className={classes.contentInner} component="div">
          <InputPin
            pinLength={pinLength}
            pin={pin}
            onPinChange={handlePinChange}
          />
          {formik.errors ? (
            <Box
              mb={2}
              component="div"
              className="errorWrapper"
              textAlign="center"
            >
              {renderErrors()}
            </Box>
          ) : (
            <></>
          )}

          <Box marginTop={3}>
            <InputButton
              color="secondary"
              fullWidth
              size="medium"
              variant="contained"
              disabled={pin !== data.pin}
              onClick={(_) => handleAction()}
            >
              <FormattedMessage id="sharedScreen.continue" />
            </InputButton>
          </Box>
        </Box>
      </Box>

      <Overlay loading={formik.isSubmitting} />
    </>
  );
};
